export const FavoritesSection = {
  title: 'Favorito',
  removeButtonTitle: 'Eliminar todo',
  more: 'Más',
  form: 'Formulario',
  formTitle:
    'Seleccione los servicios que le interesan y rellene el formulario para que podamos contactar con usted.',
};
